import React from "react";
import BusinessOrdersTableComponent from "../../components/orders/BusinessOrdersTableComponent";
import useAccount from "../../hooks/useAccount";

const BusinessDashboardPageComponent = () => {
  const { isLoggedIn, logout, userInfo } = useAccount();
  return (
    <div>
      <h3>שלום {userInfo.businessCustomer?.firstName}</h3>
      <BusinessOrdersTableComponent />
    </div>
  );
};

export default BusinessDashboardPageComponent;
